/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Never_VerifiedInputs */

const cs_portals_never_verified = /** @type {(inputs: Portals_Never_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nikdy neověřeno`)
};

const en_portals_never_verified = /** @type {(inputs: Portals_Never_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never verified`)
};

/**
* | output |
* | --- |
* | "Never verified" |
*
* @param {Portals_Never_VerifiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_never_verified = /** @type {((inputs?: Portals_Never_VerifiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Never_VerifiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_never_verified(inputs)
	return cs_portals_never_verified(inputs)
});